import { useState } from "react";
import Detalle from "./Detail";
import { useParams } from "react-router";

import { PageTabs } from "@/components/ui/page-tabs";

type TableDetailTabsType = "detalles";

const tableDetailTabs = [{ label: "Detalles", key: "detalles" }];

export const DetalleTabla = () => {
  const [activeTab, setActiveTab] = useState<TableDetailTabsType>("detalles");

  const { id } = useParams();

  return (
    <div className="w-full flex flex-col max-h-full overflow-hidden h-full">
      {/* Tabs */}
      <PageTabs
        tabs={tableDetailTabs}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as TableDetailTabsType);
        }}
      />

      {activeTab === "detalles" ? <Detalle tableId={id as string} /> : <></>}
    </div>
  );
};
